/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getListingResources} from '../api'

 export const useQueryGetListingResources = createReactQueryHook('getListingResources', getListingResources)
